import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { Mode } from 'core/slices/session';

const mode = (state: RootState) => state.session.mode;

export const selectSessionMode = (state: RootState): Mode => state.session.mode;

export const selectIsAdmin = createSelector([mode], (mode: Mode) => {
  return mode === Mode.ADMIN;
});
